import {html} from 'lit';
import {customElement} from 'lit/decorators.js';
import B2bElement from '../../../../b2b-element.js';
import defaultStyle from "../../../b2b-public-styles.scss";

@customElement('b2b-public-logout')
export class B2bPublicLogout extends B2bElement {
  static styles = [defaultStyle];


  render() {
    return html`
      <mta-page-title page-name="logout" title="Signed out"></mta-page-title>
      <div>
          <mta-icon class="check-icon" icon="check_circle"></mta-icon>
        <h1>You have been logged out</h1>
        <p><mta-icon class="login-icon" icon="login"></mta-icon><a href="#/auth/login">Back to Login</a></p>
      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    try {
      const res = fetch("/b2b/public/logout",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          }
        });
    } catch (err) {
      console.error(err);
    }
  }
}